import { createStore } from "vuex";
import globalModule from "./modules/global";

export default createStore({
  modules: {
    global: globalModule
  },
});
